import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
// Constants
import constants from "./constants/language.constants";
import storageConstants from "../../constants/storage";
// Configurations
import intlConfig from "../../configurations/intl";
var extractRegionFromLocale = function extractRegionFromLocale(locale) {
  var _locale$split;
  return locale === null || locale === void 0 ? void 0 : (_locale$split = locale.split(constants.SPLIT_REGEX, 1)) === null || _locale$split === void 0 ? void 0 : _locale$split[0];
};
var getLocaleFromBrowser = function getLocaleFromBrowser() {
  return intlConfig.locales[extractRegionFromLocale(window.navigator.language)];
};
var getUILocale = function getUILocale() {
  return localStorage.getItem(storageConstants.LOCALSTORAGE_IDS.LOCALE) || getLocaleFromBrowser() || intlConfig.locales[intlConfig.countries.EN];
};
var getISOCountry = function getISOCountry() {
  return localStorage.getItem(storageConstants.LOCALSTORAGE_IDS.COUNTRY) || intlConfig.isoCodes[extractRegionFromLocale(window.navigator.language)] || intlConfig.isoCodes[intlConfig.countries.EN];
};
export default {
  extractRegionFromLocale: extractRegionFromLocale,
  getLocaleFromBrowser: getLocaleFromBrowser,
  getISOCountry: getISOCountry,
  getUILocale: getUILocale
};